export const birthdayFilterOptions = [
  { value: "today", label: "Birthdays today" },
  { value: "exact", label: "Exact birthday" },
  { value: "month", label: "Birthdays in month" },
  { value: "next_7_days", label: "Birthdays in the next 7 days" },
  { value: "next_30_days", label: "Birthdays in the next 30 days" },
  { value: "has", label: "Has birthdate" },
  { value: "missing", label: "Missing birthdate" },
];

export const jalaliMonthNames = [
  "Farvardin",
  "Ordibehesht",
  "Khordad",
  "Tir",
  "Mordad",
  "Shahrivar",
  "Mehr",
  "Aban",
  "Azar",
  "Dey",
  "Bahman",
  "Esfand",
];

export const birthdayDays = month => {
  const maximumDay = Number(month) > 6 ? 30 : 31;
  return Array.from({ length: maximumDay }, (_, index) => index + 1);
};

export const normalizeBirthdayFilters = filters => {
  if (!["exact", "month"].includes(filters.birthday_filter)) filters.birth_month = "";
  if (filters.birthday_filter !== "exact") filters.birth_day = "";
  if (filters.birth_day && !birthdayDays(filters.birth_month).includes(Number(filters.birth_day))) {
    filters.birth_day = "";
  }
};

export const birthdayFilterIsIncomplete = filters => {
  if (filters.birthday_filter === "exact") return !filters.birth_month || !filters.birth_day;
  if (filters.birthday_filter === "month") return !filters.birth_month;
  return false;
};
